import { EndOfJourneyColumnCode } from '../../lib/types/models/end-of-journey-template/end-of-journey-column-code'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyColumnCodes(): Promise<EndOfJourneyColumnCode[]> {
  return restApiClient.url(API['end-of-journey-templates'].getColumnCodes.url).get()
}
